'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import PropTypes from 'prop-types';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import ReviewBody from 'ecosystem-marketplace-core/components/reviews/ReviewBody';
import ReviewerInfo from 'ecosystem-marketplace-core/components/reviews/ReviewerInfo';
import ReviewReplyThread from 'ecosystem-marketplace-core/components/reviews/ReviewReplyThread';
import { RatingAxes } from 'ecosystem-marketplace-core/constants/reviews/RatingAxes';
import Review from 'ecosystem-marketplace-core/records/Review';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UISection from 'UIComponents/section/UISection';
import withReportModalState from './withReportModalState'; // Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one

const DetailsReviewRenderer = ({
  borderBottom,
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "p-y-8",
    style: {
      minWidth: '300px',
      width: '100%',
      borderBottom: borderBottom && `1px solid ${GREAT_WHITE}`
    },
    children: [/*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(Rating, {
        direction: "column",
        label: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: review.get('createdAt'),
          format: "ll",
          type: "userTz"
        }),
        rating: review.get('ratings').get(RatingAxes.OVERALL),
        showTextRating: true
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      review: review,
      searchTerm: searchTerm
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      inline: true,
      review: review
    }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.get('reply'),
      onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
    }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
  });
};

DetailsReviewRenderer.propTypes = {
  borderBottom: PropTypes.bool,
  isCustomer: PropTypes.bool.isRequired,
  onReplyModalOpen: PropTypes.func.isRequired,
  review: PropTypes.instanceOf(Review).isRequired,
  reviewModalOpen: PropTypes.bool.isRequired,
  replyModalOpen: PropTypes.bool.isRequired,
  reportReviewModal: PropTypes.node.isRequired,
  reportReplyModal: PropTypes.node.isRequired,
  reviewActionsList: PropTypes.node.isRequired,
  searchTerm: PropTypes.string
};
export default withReportModalState(DetailsReviewRenderer);